import axios from "axios";

export const getPayInData = async ({ fromDate, toDate, searchQuery, page, size }) => {
  console.log(page, size);
  try {
    const params = {
      page: page,    // Default to 0 if no page is passed
      size: size,   // Default to 10 if no size is passed
    };

    // Add filters if they exist
    if (fromDate && toDate) {
      params.fromDate = fromDate;
      params.toDate = toDate;
    }

    if (searchQuery) {
      params.searchBy = searchQuery;
    }

    // Make the API request
    const response = await axios.get("https://api.ipaisa.co.in/myapp/auth/easTxnDetails", { params });

    return response;
  } catch (error) {
    console.error("API Error:", error);
    return { body: { message: "Error fetching data" }, statusCodeValue: 500 };
  }
};

